// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconMyLocation = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 25', fill: 'none', ...props },
    <path
      d="M19.754 4.245a.828.828 0 00-.983-.145L4.44 11.766a.833.833 0 00.393 1.567h5.833v5.834a.833.833 0 00.831.833c.307 0 .59-.17.733-.44l7.667-14.334a.829.829 0 00-.142-.98z"
      fill="currentColor"
    />
  );
export default SvgIconMyLocation;
